import { useEffect, useState } from 'react'
import api from '../services/api'
import type { ChaveOcorrencia } from './OcorrenciaTextoModal'

// Relatório do Funcionário (TMOTOC1) — relato livre em ocomot.ocodss; veículo só leitura, como no ERP

const LIMITE = 800

export default function OcorrenciaRelatoModal({ chave, funcionario, tipo, onClose, somenteLeitura }: {
  chave: ChaveOcorrencia; funcionario: string; tipo: string; onClose: () => void; somenteLeitura?: boolean
}) {
  const [relato, setRelato] = useState<string | null>(null)
  const [original, setOriginal] = useState('')
  const [extra, setExtra] = useState<{ ocovei: string; veipla: string; motpra: number | null }>({ ocovei: '', veipla: '', motpra: null })
  const [erro, setErro] = useState('')
  const [aviso, setAviso] = useState('')
  const [salvando, setSalvando] = useState(false)

  useEffect(() => {
    api.get('/ocorrencias-funcionarios/relato', { params: chave })
      .then(r => {
        setRelato(r.data.relato); setOriginal(r.data.relato)
        setExtra({ ocovei: r.data.ocovei ?? '', veipla: r.data.veipla ?? '', motpra: r.data.motpra ?? null })
      })
      .catch(() => setErro('Não foi possível carregar o relatório do funcionário.'))
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  async function salvar() {
    setErro(''); setAviso('')
    setSalvando(true)
    try {
      const r = await api.put('/ocorrencias-funcionarios/relato', { ...chave, relato })
      setOriginal(relato ?? '')
      setAviso(r.data?.semAlteracao ? 'Nenhuma alteração para salvar.' : 'Relatório salvo.')
    } catch (e: any) {
      setErro(e?.response?.data?.error || 'Erro ao salvar o relatório.')
    } finally {
      setSalvando(false)
    }
  }

  function fechar() {
    if (relato !== null && relato !== original && !window.confirm('O relatório foi alterado e não foi salvo. Fechar mesmo assim?')) return
    onClose()
  }

  const info = (rot: string, val: string | number) => (
    <div style={{ minWidth: 0 }}>
      <div style={{ fontSize: '0.68rem', fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{rot}</div>
      <div style={{ fontSize: '0.88rem', fontWeight: 600, color: '#1b3f7b', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={String(val)}>{val}</div>
    </div>
  )

  return (
    <div className="modal-overlay" style={{ zIndex: 1300 }} onClick={e => e.target === e.currentTarget && fechar()}>
      <div className="modal-box" style={{ maxWidth: 760, maxHeight: '92vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
        <div className="modal-header" style={{ background: 'linear-gradient(135deg, #1a6ea8, #14547f)', gap: '1rem' }}>
          <div style={{ minWidth: 0 }}><h2>Relatório do Funcionário</h2></div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexShrink: 0, marginLeft: 'auto' }}>
            <span style={{ fontSize: '0.78rem', fontWeight: 700, color: 'rgba(219,234,254,0.8)' }}>TMOTOC1</span>
            <button className="modal-fechar" onClick={fechar}>✕</button>
          </div>
        </div>

        <div className="modal-corpo" style={{ background: '#f1f5fb' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '110px minmax(0, 1fr) 70px 90px', gap: '0.75rem', padding: '0.75rem 1rem',
            background: '#fff', border: '1px solid #c7d6ea', borderRadius: 10, marginBottom: '0.9rem' }}>
            {info('Data', chave.ocodat.split('-').reverse().join('/'))}
            {info('Funcionário', funcionario || '—')}
            {info('Estab.', extra.motpra ?? '—')}
            {info('Número', chave.oconro)}
            <div style={{ gridColumn: '1 / 3', minWidth: 0 }}>{info('Tipo', tipo)}</div>
            <div style={{ gridColumn: '3 / 5', minWidth: 0 }}>{info('Veículo', extra.ocovei ? `${extra.ocovei}${extra.veipla ? ' - ' + extra.veipla : ''}` : '—')}</div>
          </div>

          {relato === null ? (
            <p style={{ color: erro ? '#dc2626' : '#6b7280' }}>{erro || 'Carregando...'}</p>
          ) : (
            <>
              <textarea value={relato} readOnly={somenteLeitura} maxLength={LIMITE} rows={12} spellCheck autoFocus placeholder="Relato do funcionário sobre a ocorrência..."
                style={{ width: '100%', boxSizing: 'border-box', fontSize: '0.88rem', lineHeight: 1.5, resize: 'vertical',
                  padding: '0.6rem 0.8rem', border: '1.5px solid #c7d6ea', borderRadius: 8, background: '#fff', fontFamily: 'inherit' }}
                onChange={e => setRelato(e.target.value)} />
              <div style={{ fontSize: '0.72rem', color: relato.length >= LIMITE ? '#b91c1c' : '#6b7280', textAlign: 'right', marginTop: 4 }}>{relato.length} / {LIMITE}</div>
            </>
          )}

          {relato !== null && erro && <p style={{ color: '#dc2626', fontSize: '0.82rem', margin: '0.8rem 0 0' }}>{erro}</p>}
          {aviso && <p style={{ color: '#16a34a', fontSize: '0.82rem', margin: '0.8rem 0 0' }}>{aviso}</p>}
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={fechar}>Fechar</button>
          {!somenteLeitura && <button className="btn btn-primary" onClick={salvar} disabled={salvando || relato === null}>{salvando ? 'Salvando...' : 'Salvar'}</button>}
        </div>
      </div>
    </div>
  )
}
